import reducer from './preferencesReducer';
import actions from './preferencesActions';
import createProvider from '../../utilities/createProvider';

export default createProvider(actions, reducer);
